@layer module {
.dropdown-input :global(.select-input__indicator) {
            display: flex;
            flex: 0 0 auto;
            align-items: center;
            justify-content: center;
    }

.dropdown-chevron {
            display: inline-flex;
            flex: 0 0 auto;
            align-items: center;
            justify-content: center;
            transition: transform 160ms ease;
    }

.dropdown-chevron svg {
            display: block;
            overflow: visible;
    }

.dropdown-chevron.expanded {
            transform: rotate(180deg);
    }

.dropdown-input :global(.select-input__menu),
:global(.select-input__menu-portal .select-input__menu) {
            left: 0;
            right: 0;
            overflow: hidden;
    }

.dropdown-input :global(.select-input__menu-list),
:global(.select-input__menu-portal .select-input__menu-list) {
            overflow-x: hidden;
    }

.dropdown-input :global(.select-input__option),
:global(.select-input__menu-portal .select-input__option) {
            border-radius: 0;
            white-space: nowrap;
            cursor: pointer;
    }

:where(.dropdown-input) :global(.custom-option-wrapper .custom-option-additional),
:where(:global(.select-input__menu-portal)) :global(.custom-option-wrapper .custom-option-additional) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
    }

:where(.dropdown-input):not(.dropdown-input--filter) :global(.select-input__multi-value) {
            align-items: center;
    }

.dropdown-option-row {
            display: flex;
            align-items: center;
    }

.dropdown-option-icon {
            display: grid;
            flex: 0 0 auto;
            place-items: center;
    }

.dropdown-option-text {
            display: flex;
            flex-flow: column nowrap;
            min-width: 0;
            text-align: left;
    }

.dropdown-option-text > span {
            overflow: hidden;
            text-overflow: ellipsis;
    }
} // layer module










@layer app {
.dropdown-input-wrapper--compact {
            margin-bottom: 0;
    }

.dropdown-input-wrapper--compact :global(.input-container) {
            min-height: $size-40;
            padding: 0;
    }

.dropdown-input {
            width: 100%;
    }

.dropdown-input :global(.select-input__control) {
            width: 100%;
            min-height: $size-44;
            padding: 0;
    }

.dropdown-input :global(.select-input__value-container) {
            padding: 0;
    }

.dropdown-input :global(.select-input__indicator) {
            padding: 0;
    }

.dropdown-chevron {
            width: $size-12;
            height: $size-7;
    }

.dropdown-chevron svg {
            width: $size-12;
            height: $size-7;
    }

.dropdown-input :global(.select-input__menu),
:global(.select-input__menu-portal .select-input__menu) {
            width: 100%;
            margin: $size-10 0 0;
            padding: 0 0 $size-8;
    }

.dropdown-input :global(.select-input__menu-list),
:global(.select-input__menu-portal .select-input__menu-list) {
            max-height: $size-300;
            padding: $size-4 0;
    }

.dropdown-input :global(.select-input__option),
:global(.select-input__menu-portal .select-input__option) {
            width: 100%;
            margin: 0;
            padding: $size-10 $size-20;
    }

.dropdown-input :global(.select-input__control) {
            height: $size-44;
    }

.dropdown-input--multi :global(.select-input__control) {
            height: auto;
    }

.dropdown-input--filter :global(.select-input__control) {
            height: $size-44;
            min-height: $size-44;
            padding: 0 0 0 $size-10;
    }

.dropdown-input--filter :global(.select-input__value-container) {
            padding: 0 $size-8;
    }

.dropdown-input--filter :global(.select-input__clear-indicator) {
            padding: 0 $size-8 0 0;
    }

.dropdown-input--filter :global(.select-input__input) {
            margin: 0;
            padding: 0;
    }

:where(.dropdown-input):not(.dropdown-input--filter) :global(.select-input__multi-value) {
            padding: $size-2 $size-6 $size-2 $size-8;
            gap: $size-4;
    }

.dropdown-input--compact :global(.select-input__control) {
            height: $size-40;
            min-height: auto;
            padding: 0 $size-12 0 $size-10;
    }

.dropdown-option-icon {
            width: $size-26;
            height: $size-26;
            margin-right: $size-10;
    }

.input-wrapper--search:global(.input-wrapper) {
            margin-bottom: 0;
    }

.input-wrapper--search :global(.input-container),
.input-wrapper--search :global(.input-container.focused) {
            background: transparent;
            border: none;
            border-bottom: 1px solid var(--search-input-border);
            border-radius: 0;
            height: $size-40;
            padding: 0 $size-30 0 0;
    }

.input-wrapper--search :global(.custom-input),
.input-wrapper--search :global(.custom-input::placeholder) {
            color: var(--input-container-placeholder);
            font-size: var(--font-size-base);
            font-style: normal;
            font-weight: 500;
            height: $size-40;
            line-height: $size-17;
    }

.dropdown-input-wrapper--compact {
            margin-bottom: 0;
    }

.dropdown-input-wrapper--compact :global(.input-container),
.dropdown-input-wrapper--compact :global(.input-container.focused) {
            background: transparent;
            border: none;
            padding: 0;
    }

.dropdown-chevron {
            color: var(--select-indicator);
    }

.dropdown-chevron.dropdown-chevron--contrast {
            color: var(--banky-white);
    }

.dropdown-input {
            font-size: var(--font-size-base);
    }

.dropdown-input :global(.select-input__control) {
            background: transparent;
            border: none;
            border-radius: 0;
            font-size: var(--font-size-base);
            line-height: $size-17;
    }

:where(.dropdown-input) :global(.select-input__control:hover),
.dropdown-input :global(.select-input__control--menu-is-open),
:where(.dropdown-input).error :global(.select-input__control) {
            background: transparent;
            border: none;
    }

.dropdown-input :global(.select-input__value-container),
.dropdown-input :global(.select-input__placeholder),
.dropdown-input :global(.select-input__single-value) {
            font-size: var(--font-size-base);
    }

.dropdown-input :global(.select-input__placeholder) {
            color: var(--input-container-placeholder);
            font-size: var(--input-placeholder-font-size);
            font-style: var(--input-placeholder-font-style);
            font-weight: var(--input-placeholder-font-weight);
            line-height: var(--input-placeholder-line-height);
    }

.dropdown-input :global(.select-input__single-value) {
            color: var(--select-option-text);
    }

.dropdown-input :global(.select-input__indicator) {
            color: var(--select-indicator);
    }

.dropdown-input :global(.select-input__multi-value) {
            background: var(--color-brand-tint);
            border-radius: $size-6;
    }

.dropdown-chevron svg path {
            stroke: currentColor;
            stroke-width: 1.2;
            fill: none;
    }

.dropdown-input :global(.select-input__menu),
:global(.select-input__menu-portal .select-input__menu) {
            background: var(--select-menu-bg);
            border: none;
            border-radius: $size-10;
            box-shadow: var(--select-menu-shadow);
            font-size: var(--font-size-base);
    }

.dropdown-input :global(.select-input__option),
:global(.select-input__menu-portal .select-input__option) {
            background: var(--select-option-bg);
            color: var(--select-option-text);
            font-size: var(--font-size-base);
            font-weight: normal;
            line-height: $size-17;
    }

.dropdown-input :global(.select-input__option--is-focused),
:where(.dropdown-input) :global(.custom-option-wrapper:hover),
:global(.select-input__menu-portal .select-input__option--is-focused),
:where(:global(.select-input__menu-portal)) :global(.custom-option-wrapper:hover),
:global(.dropdown-option):not(:global(.disabled)):hover,
:global(.dropdown-option):not(:global(.disabled)):focus-visible {
            background: var(--select-focused-bg);
            color: var(--select-focused-text);
    }

.dropdown-input :global(.select-input__option--is-selected),
:where(.dropdown-input) :global(.custom-option-wrapper[aria-selected='true']),
:global(.select-input__menu-portal .select-input__option--is-selected),
:where(:global(.select-input__menu-portal)) :global(.custom-option-wrapper[aria-selected='true']) {
            background: var(--select-selected-bg);
            color: var(--select-selected-text);
            font-weight: 500;
    }

.dropdown-input :global(.option--is-new-button),
:global(.select-input__menu-portal .option--is-new-button) {
            background: var(--select-option-bg);
            color: var(--select-option-text);
            border-radius: $size-3;
            text-align: center;
    }

:where(.dropdown-input) :global(.custom-option-wrapper .custom-option-additional),
:where(:global(.select-input__menu-portal)) :global(.custom-option-wrapper .custom-option-additional) {
            color: var(--input-custom-option-additional);
            font-size: var(--font-size-sm);
            line-height: $size-13;
    }

.dropdown-input--filter :global(.select-input__control) {
            color: var(--banky-white);
            border-radius: $size-10;
            transition: none;
            box-shadow: none;
            outline: none;
            cursor: pointer;
    }

.dropdown-input--filter :global(.select-input__control--menu-is-open) {
            color: var(--banky-black);
    }

.dropdown-input--filter :global(.select-input__multi-value) {
            background-color: var(--banky-royal-blue--50);
            border-radius: $size-3;
            color: inherit;
    }

.dropdown-input--filter :global(.select-input__multi-value__label) {
            color: inherit;
    }

.dropdown-input--filter :global(.select-input__menu) {
            padding: $size-10 0;
    }

.dropdown-input--filter :global(.select-input__option) {
            text-align: left;
    }

.dropdown-input--compact :global(.select-input__control) {
            cursor: pointer;
            text-align: center;
            background-color: var(--control-surface-bg);
            border: 1px solid var(--control-surface-border-color);
            border-radius: $size-10;
            box-shadow: var(--control-surface-shadow);
    }

.dropdown-input--compact :global(.select-input__single-value) {
            width: 100%;
            margin-left: 0;
            color: var(--banky-black);
            font-weight: 400;
            line-height: $size-20;
    }

.dropdown-input--compact :global(.select-input__placeholder) {
            margin-left: $size-22;
            color: var(--banky-black);
            text-transform: capitalize;
    }

.dropdown-option-description {
            color: var(--input-custom-option-additional);
            font-size: var(--font-size-sm);
            font-weight: 400;
            line-height: $size-14;
    }
} // layer app










@layer context {
:global(.filter-pill) .dropdown-input-wrapper {
            flex: 1 1 auto;
            min-width: $size-60;
            margin: 0;
    }

:global(.filter-pill) .dropdown-input :global(.select-input__control) {
            height: $size-34;
            min-height: $size-34;
            padding: 0;
            border: none;
            background: transparent;
            box-shadow: none;
            cursor: pointer;
    }

:global(.filter-pill) .dropdown-input :global(.select-input__single-value),
:global(.filter-pill) .dropdown-input :global(.select-input__placeholder) {
            margin: 0;
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }

:global(.filter-pill) .dropdown-input :global(.select-input__multi-value) {
            align-items: normal;
            gap: 0;
            margin: 0 $size-2;
            padding: 0;
            background: var(--color-brand-tint);
            border-radius: $size-6;
    }

:global(.filter-pill) .dropdown-input :global(.select-input__menu) {
            min-width: $size-200;
    }

:global(.header-menu-pill) .dropdown-chevron {
            color: inherit;
    }

.dropdown-input-wrapper:global(.account-currency-selector) {
            width: auto;
            min-width: $size-145;
            margin-bottom: 0;
    }

:global(.select-role-wrapper) .dropdown-input :global(.select-input__menu) {
            left: $size-16;
    }

:global(.select-payment-method-dropdown-wrapper .input-container) {
            min-height: $size-44;
            height: $size-44;
            padding: $size-10 $size-18 $size-10 var(--input-placeholder-inline-inset);
            gap: $size-15;
            justify-content: space-between;
    }

:global(.select-payment-method-dropdown-wrapper .select-input),
:global(.select-payment-method-dropdown-wrapper .select-input__control) {
            flex: 1;
            min-height: auto;
            height: auto;
    }

:global(.account-form) .dropdown-input-wrapper {
            margin-bottom: 0;
    }

:global(.account-form) .dropdown-input-wrapper :global(.input-container) {
            padding: 0;
            border-color: transparent;
            background: transparent;
    }

:global(.account-form) .dropdown-option-text {
            color: var(--text-primary);
            font-size: var(--font-size-sm);
    }

:global(.account-form) .dropdown-option-description {
            color: var(--text-secondary);
    }

:global(.account-form) .dropdown-option-text > span {
            white-space: normal;
    }
} // layer context
